import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/fornecedor')({
    beforeLoad: () =>
        validateRoute({
            fintech: true,
            validatePermission: ({ upp_cadastro_fornecedor }) =>
                isPermissionParcialOrFull(upp_cadastro_fornecedor),
        }),
});
